export class CreateProfileModel {
  public descricao = ''
}

export class ProfileModel {
  public id?: number
  public descricao?: string
}

export class EditProfileModel {
  public id = 0
  public descricao = ''
}

export class DeleteProfileModel {
  public id = 0
  public descricao = ''
}

export class SearchProfileModel {
  public descricao = ''
}

export class CreateProfileResponse {
  public response: any
}
export class EditProfileResponse {
  public response: any
}
export class DeleteProfileResponse {
  public response: any
}
export class PagedProfileResponse {
  public response: any
}
